export const contactsData = {
    email: 'bhavyashreekp11@gmail.com',
    phone: '+8088195836',
    address: 'Tiptur, Karnataka India',
    github: 'https://github.com/BhavyashreeKP',
    linkedIn: 'https://www.linkedin.com/in/bhavyashree-k-p-4329b6259?',
    
    // medium: 'https://medium.com/@abusaid-bd',
    // stackOverflow: 'https://stackoverflow.com/users/16840768/abu-said',
    devUsername: "Bhavya"
}